import $ from 'jquery'
import {register} from '@shopify/theme-sections'
import {gql, GraphQLClient} from 'graphql-request'
import {setPopupScreenLock} from '../modules/screen-lock'
import {isAu} from '../util/countryCheck'
import {formatCurrencyByLocale} from '../util/formatCurrencyByLocale'
import {GQL_END_POINT} from '@/scripts/configs/store'
import {cartGraphQLQuery} from '@/scripts/util/cartLineItems.gql'

export default register(`template-cart`, {
    onLoad() {
        /**
         * New WeRD Cart Functionality
         * Set the Cookie once the Form has been submitted
         * ===> Cookies.set("_rent_submit", "1", { expires: 1 });
         */

        /**
         * set GA Object
         */
        const GA_OBJECT = {}

        // start...
        const $popup = document.querySelectorAll(`[data-trigger="popup"]`)
        // finish...
        const endpoint = GQL_END_POINT
        const cartItemIds = []
        const cartItemProducts = document.querySelectorAll(`[data-cart-item-id]`)
        const cart = document.querySelector(`[data-section-id='template-cart']`)

        // Only appear on AU currently, will be undefined otherwise.
        const financePurchaseTypeButton = document.querySelector(`#finance_toggle_button`)
        const financeCartForm = document.querySelector(`#finance_checkout_form`)

        const creditCardPurchaseTypeButton = document.querySelector(`#credit_card_toggle_button`)
        const enquiryPurchaseTypeButton = document.querySelector(`#enquiry_toggle_button`)

        const creditCardCartForm = document.querySelector(`#credit_card_checkout_form`)
        const enquiryCartForm = document.querySelector(`#enquiry_checkout_form`)

        // Rent-Try-Buy & Lease-To-Keep
        const rtb_rental_option = document.querySelector(`#rtb_rental_option`)
        const ltk_rental_option = document.querySelector(`#ltk_rental_option`)

        /**
         * Helper Function to check if the cart is empty
         * @returns - boolean
         */
        const isCartEmpty = () => {
            return Array.isArray(cartItemIds) && !cartItemIds.length
        }

        /**
         * Loop over the Cart Item Product IDs and push to array
         */
        for (const cartItem of cartItemProducts) {
            const productId = cartItem.dataset.cartItemId
            cartItemIds.push(btoa(`gid://shopify/Product/${productId}`))
        }

        const setRentTryBuyValue = products => {
            const productsWithRentalPrice = products
                .map(product => ({
                    id: product && product.id,
                    rentalPrice: JSON.parse(product?.weeklyrental.value).amount || product.price.maxVariantPrice.amount * 0.055 * 12 / 52
                }))
                .filter(a => a.rentalPrice)

            const totalWeeklyRentalPrice = productsWithRentalPrice.reduce(
                (accumulator, currentValue) => {
                    const price = currentValue?.rentalPrice ?? 0
                    return accumulator + +price
                },
                0
            )

            const formattedPrice = `${formatCurrencyByLocale({
                amount: totalWeeklyRentalPrice * 100, format: window.theme.moneyFormat
            })}/wk`

            const formattedTotalPrice = `${formatCurrencyByLocale({
                amount: totalWeeklyRentalPrice * 52 * 100, format: window.theme.moneyFormat
            })}`

            $(`[data-total-rent-price]`).html(totalWeeklyRentalPrice > 0 ? formattedPrice : `N/A`)

            $(`[data-total-rent-try-buy]`).html(totalWeeklyRentalPrice > 0 ? formattedTotalPrice : `N/A`)

            /**
             * Push Formatted Value to GA Object
             */
            const gaRentalTotalAmount = `${formatCurrencyByLocale({
                amount: totalWeeklyRentalPrice * 100, format: window.theme.moneyFormat
            })}`
            GA_OBJECT.rentalTotalAmount = gaRentalTotalAmount
        }

        /**
         * PMTFunction is a function used within financial formulas
         * Resource: https://corporatefinanceinstitute.com/resources/excel/functions/pmt-function/#:~:text=The%20PMT%20function%20uses%20the,future%20payments%20is%20worth%20now
         */
        function PMTFunction(rate, nperiod, pv, fv, type) {
            if (!fv) fv = 0
            if (!type) type = 0

            if (rate == 0) return -(pv + fv) / nperiod

            let pvif = Math.pow(1 + rate, nperiod)
            let pmt = (rate / (pvif - 1)) * -(pv * pvif + fv)

            if (type == 1) {
                pmt /= 1 + rate
            }

            return pmt
        }

        const setLeaseToKeepValue = products => {
            // Going off the Equipment Costs (Sub Totals)
            let subTotalCartPrice = document.querySelector(`[data-sub-total]`)
            subTotalCartPrice = subTotalCartPrice && subTotalCartPrice.dataset && subTotalCartPrice.dataset.subTotal

            const totalLeaseToKeepPrice = getLeaseToKeepProductPrice({}, subTotalCartPrice)
            const formattedPrice = `${formatCurrencyByLocale({
                amount: totalLeaseToKeepPrice, format: window.theme.moneyFormat
            })}/mth`

            const formattedTotalPrice = `${formatCurrencyByLocale({
                amount: totalLeaseToKeepPrice * 48, format: window.theme.moneyFormat
            })}`

            $(`[data-total-lease-price]`).html(totalLeaseToKeepPrice > 0 ? formattedPrice : `N/A`)

            $(`[data-total-lease-to-keep]`).html(totalLeaseToKeepPrice > 0 ? formattedTotalPrice : `N/A`)

            /**
             * Set the GA Object
             * subTotalCartPrice -
             */
            const gaSubTotalCartPrice = `${formatCurrencyByLocale({
                amount: subTotalCartPrice, format: window.theme.moneyFormat
            })}`
            GA_OBJECT.subTotalCartPrice = gaSubTotalCartPrice
        }

        /**
         * Get the Produce Price
         * @param {object} product - Takes in the Product GraphQl response
         * @returns - the Purchase Price object for the product
         */
        const getProductPurchasePrice = product => {
            const {
                variants: {edges}
            } = product
            const {compareAtPriceV2, priceV2} = edges[0].node
            return {
                amount: priceV2 && priceV2.amount, salePrice: compareAtPriceV2 && compareAtPriceV2.amount
            }
        }

        /**
         * Get the Lease To Keep Produce Price
         * @param {object} product - Takes in the Product GraphQl response
         * @returns - the calculated Weekly Lease To Keep Price
         */
        const getLeaseToKeepProductPrice = (product, value) => {
            const term = 4 // 4 years or 5 years
            const numOfTermMonth = term * 12
            const monthlyValue = PMTFunction(21 / 1200, numOfTermMonth, -1 * value, 0, 1)
            return monthlyValue ? monthlyValue : null
        }

        /**
         * Make the Graph QL API to collect the
         * Metafield Data for Weekly Prices
         */
        const makeGraphQLQuery = () => {
            const namespace = window.Shopify.shop.includes(`staging-au`) ? `storefront` : `dtk`
            const client = new GraphQLClient(endpoint, {
                headers: {
                    'X-Shopify-Storefront-Access-Token': window.theme.cartjs.storefrontApiToken
                }
            })
            client
                .request(cartGraphQLQuery, {
                    ids: cartItemIds,
                    namespace: namespace
                })
                .then(data => {
                    const {nodes} = data
                    return nodes
                })
                .then(nodes => {
                    if (!isCartEmpty()) {
                        setRentTryBuyValue(nodes)
                        setLeaseToKeepValue(nodes)

                        GA_OBJECT.productsArray = nodes
                    }
                    cart.classList.add(`visible`)
                })
                .then(() => {
                    /**
                     * Fire the GA Event
                     */
                    fireGAevent()
                })
        }
        makeGraphQLQuery()

        /**
         * Scroll to the top of the window
         */
        const scrollToTop = () => {
            // There is a CSS rule that puts the height of the
            // '.body-wrapper' to 100vh and overflow scroll.
            // Which effects the scroll event on mobile
            let dist = 0
            if (window.innerWidth > 760) {
                window.scroll({
                    top: dist, behavior: `smooth`
                })
            } else {
                dist = document.querySelector(`.cart-template__continue-shopping`).offsetTop
                window.scroll({
                    top: dist, behavior: `smooth`
                })
            }
        }
        /**
         * Toggle the Purchase Types
         */
        const activateEnquiryCheckoutOption = () => {
            // Fade In Enquiry Form
            if (isAu()) {
                financeCartForm && financeCartForm.classList.add(`hide`)
            }
            creditCardCartForm && creditCardCartForm.classList.add(`hide`)
            enquiryCartForm && enquiryCartForm.classList.remove(`hide`)

            setTimeout(() => {
                if (isAu()) {
                    financePurchaseTypeButton && financePurchaseTypeButton.classList.remove(`active`)
                    financeCartForm && financeCartForm.classList.remove(`active`)
                }

                creditCardPurchaseTypeButton && creditCardPurchaseTypeButton.classList.remove(`active`)
                creditCardCartForm && creditCardCartForm.classList.remove(`active`)

                enquiryPurchaseTypeButton && enquiryPurchaseTypeButton.classList.add(`active`)
                enquiryCartForm && enquiryCartForm.classList.add(`active`)
            }, 80)
            window.sessionStorage.setItem(`silverchef_checkout_type`, `enquiry`)
        }
        const activateCreditCardCheckoutOption = () => {
            // Fade In Credit Card Form
            if (isAu()) {
                financeCartForm && financeCartForm.classList.add(`hide`)
            }
            creditCardCartForm && creditCardCartForm.classList.remove(`hide`)
            enquiryCartForm && enquiryCartForm.classList.add(`hide`)

            setTimeout(() => {
                if (isAu()) {
                    financePurchaseTypeButton && financePurchaseTypeButton.classList.remove(`active`)
                    financeCartForm && financeCartForm.classList.remove(`active`)
                }

                creditCardPurchaseTypeButton && creditCardPurchaseTypeButton.classList.add(`active`)
                creditCardCartForm && creditCardCartForm.classList.add(`active`)

                enquiryPurchaseTypeButton && enquiryPurchaseTypeButton.classList.remove(`active`)
                enquiryCartForm && enquiryCartForm.classList.remove(`active`)
            }, 80)
            window.sessionStorage.setItem(`silverchef_checkout_type`, `credit_card`)
        }

        const activateFinanceCheckoutOption = () => {
            // Fade In Credit Card Form
            // Don't need AU check here, as this is only used for AU
            financeCartForm && financeCartForm.classList.remove(`hide`)
            creditCardCartForm && creditCardCartForm.classList.add(`hide`)
            enquiryCartForm && enquiryCartForm.classList.add(`hide`)

            setTimeout(() => {
                financePurchaseTypeButton && financePurchaseTypeButton.classList.add(`active`)
                financeCartForm && financeCartForm.classList.add(`active`)

                creditCardPurchaseTypeButton && creditCardPurchaseTypeButton.classList.remove(`active`)
                creditCardCartForm && creditCardCartForm.classList.remove(`active`)

                enquiryPurchaseTypeButton && enquiryPurchaseTypeButton.classList.remove(`active`)
                enquiryCartForm && enquiryCartForm.classList.remove(`active`)
            }, 80)
            window.sessionStorage.setItem(`silverchef_checkout_type`, `finance`)
        }
        const togglePurchaseType = (self, buttonId) => {
            scrollToTop()
            if (self.id === buttonId && !self.classList.contains(`disabled`)) {
                activateEnquiryCheckoutOption()
            } else if (isAu && self.id === `finance_toggle_button`) {
                activateFinanceCheckoutOption()
            } else {
                activateCreditCardCheckoutOption()
            }
        }

        financePurchaseTypeButton && financePurchaseTypeButton.addEventListener(`click`, function () {
            togglePurchaseType(this, ``)
        })
        creditCardPurchaseTypeButton && creditCardPurchaseTypeButton.addEventListener(`click`, function () {
            togglePurchaseType(this, ``)
        })
        enquiryPurchaseTypeButton && enquiryPurchaseTypeButton.addEventListener(`click`, function () {
            togglePurchaseType(this, `enquiry_toggle_button`)
        })
        if (!isAu) {
            rtb_rental_option && rtb_rental_option.addEventListener(`click`, function () {
                togglePurchaseType(this, `rtb_rental_option`)
            })
            ltk_rental_option && ltk_rental_option.addEventListener(`click`, function () {
                togglePurchaseType(this, `ltk_rental_option`)
            })
        }

        /**
         * Determine Checkout Type
         */
        const determineCheckoutType = () => {
            if (!isCartEmpty()) {
                const type = window.sessionStorage.getItem(`silverchef_checkout_type`)
                if (type === `finance` || (isAu() && !type)) {
                    activateFinanceCheckoutOption()
                } else if (type === `enquiry`) {
                    activateEnquiryCheckoutOption()
                } else {
                    activateCreditCardCheckoutOption()
                }
            }
        }
        document.addEventListener(`DOMContentLoaded`, determineCheckoutType)

        /**
         * Cart popup code...
         * Creating the PDP popups
         * Adding the Popups to the Product Page.
         * – About Delivery
         * – Lease-To-Keep & Rent-Try-Buy
         * – Quick Enquire
         */
        if ($popup && $popup.length > 0) {
            setPopupScreenLock({
                triggerSelector: `[data-trigger="popup"]`, closeButtonSelector: `[data-close]`
            })

            // Watch which rental button is clicked and set the left or right toggle .active
            $(`[data-popup-toggle-target]`).on(`click`, function () {
                const contentToDisplay = $(this).data(`popup-toggle-target`)
                $(`.toggle-button`).removeClass(`active`)
                $(`.toggle-button--${contentToDisplay}`).addClass(`active`)
                $(`.toggle-content`)
                    .removeClass(`active`)
                    .addClass(`hide`)
                $(`.toggle-content--${contentToDisplay}`)
                    .addClass(`active`)
                    .removeClass(`hide`)
            })

            // Toggle the LTK & RTB content
            $(`.toggle-button`).on(`click`, function () {
                const contentToDisplay = $(this).data(`target-content`)
                $(`.toggle-button`).removeClass(`active`)
                $(this).addClass(`active`)
                $(`.toggle-content`)
                    .removeClass(`active`)
                    .addClass(`hide`)
                $(`.toggle-content--${contentToDisplay}`)
                    .addClass(`active`)
                    .removeClass(`hide`)
            })
        }

        /**
         * Google analytics - Original
         */
        function fireGAevent() {
            const findProductSku = variants => {
                const sku = variants && variants.edges && variants.edges[0].node && variants.edges[0].node.sku
                return sku ? sku : null
            }

            const findTag = (tags, keyWord, trimKeyword = false) => {
                const tag = tags && tags.find(tag => tag.includes(`${keyWord}`))
                if (trimKeyword) {
                    return tag ? tag.replace(`${keyWord}`, ``) : null
                } else {
                    return tag ? tag : null
                }
            }

            const dataLayerObject = {
                event: `transaction1.0viewcart`,
                weeklyRent: GA_OBJECT.rentalTotalAmount,
                totalEquipmentFinance: GA_OBJECT.subTotalCartPrice,
                products: GA_OBJECT.productsArray.map(product => ({
                    equipmentName: product && product.title,
                    equipmentCategory: product && findTag(product.tags, `cat:`, true),
                    equipmentRefNo: product && findProductSku(product.variants)
                }))
            }

            window.dataLayer.push(dataLayerObject)
        }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload() {
    }
})
